"use strict";
// <copyright file="loaderTab.tsx" company="Top365">
// Copyright (c) Top365. All rights reserved.
// </copyright>
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_northstar_1 = require("@fluentui/react-northstar");
var _ = require('lodash');
require("./loader.scss");
/** Component for displaying loading component. */
var LoaderList = function () {
    return (React.createElement("div", { className: "tabContainer" },
        React.createElement(react_northstar_1.Skeleton, { animation: "pulse" },
            React.createElement(react_northstar_1.Grid, { styles: {
                    gridTemplateColumns: "1.1fr 0.5fr 0.5fr 0.3fr 0.2fr",
                    gridGap: "0rem 0.6rem",
                    padding: "0 0 1rem 0"
                } }, _.times(6, function (index) { return (React.createElement(React.Fragment, { key: index },
                React.createElement(react_northstar_1.Flex, { gap: "gap.large", styles: { padding: "2rem 0" } },
                    React.createElement(react_northstar_1.Skeleton.Line, { width: "100%" })),
                React.createElement(react_northstar_1.Flex, { gap: "gap.large", styles: { padding: "2rem 0" } },
                    React.createElement(react_northstar_1.Skeleton.Line, { width: "100%" })),
                React.createElement(react_northstar_1.Flex, { gap: "gap.large", styles: { padding: "2rem 0" } },
                    React.createElement(react_northstar_1.Skeleton.Line, { width: "100%" })),
                React.createElement(react_northstar_1.Flex, { gap: "gap.large", styles: { padding: "2rem 0" } },
                    React.createElement(react_northstar_1.Skeleton.Line, { width: "100%" })),
                React.createElement(react_northstar_1.Flex, { gap: "gap.large", styles: { padding: "2rem 0" } },
                    React.createElement(react_northstar_1.Skeleton.Line, { width: "100%" })))); })))));
};
exports.default = LoaderList;
//# sourceMappingURL=loaderList.js.map